
<div class="partner-success-dashboard">
  <wf-school-teacher-filter
    [districts]="districts()"
    [schools]="schools()"
    [includeAllScope]="true"
    [showTeacher]="false"
    (filterChangeEvent)="schoolTeacherFilter.set($event)"
  >
  </wf-school-teacher-filter>

  <div class="card-row">
    <div class="partner-success-card">
      <div class="stats-card-header">
        <fa-icon [icon]="enrollmentIcon" size="xl"/>
        <h2> Enrollment </h2>
      </div>
      <div class="enrollment-stats-numbers">
        <div class="number-with-label">
          {{ counts().districts | number }}
          <div>Districts</div>
        </div>
        <div class="enrollment-stats-border"></div>
        <div class="number-with-label">
          {{ counts().schools | number }}
          <div>Schools</div>
        </div>
        <div class="enrollment-stats-border"></div>
        <div class="number-with-label">
          {{ counts().teachers | number }}
          <div>Teachers</div>
        </div>
        <div class="enrollment-stats-border"></div>
        <div class="number-with-label">
          {{ counts().students | number }}
          <div>Students</div>
        </div>
      </div>
    </div>

    <div class="partner-success-card">
      <div class="stats-card-header">
        <fa-icon [icon]="onboardedIcon" size="xl"/>
        <h2> Onboarded </h2>
      </div>
      <div class="large-icon-number">
        <div class="number-with-label">
          {{ percentOnboarded() }}%
          <div>Schools Started</div>
        </div>
      </div>
    </div>

    <div class="partner-success-card">
      <div class="stats-card-header">
        <fa-icon [icon]="loginsIcon" size="xl"/>
        <h2> Logins </h2>
      </div>
      <div class="large-icon-number">
        <div class="number-with-label">
          {{  percentSchoolsWithAtLeastOneLoginWithinLastWeek() }}%
          <div>Schools with teacher logins in past week </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-row">
    <div class="partner-success-card chart-card">
      <div class="chart-card-header">
        <h2> Healthy Schools </h2>
      </div>
      <div class="gauge-chart-container">
        <canvas
          baseChart
          #percentHealthyGaugeChart
          id="percent-healthy-gauge-chart"
          type="doughnut"
          [data]="gaugeChartData()"
          [options]="gaugeChartOptions"
          [plugins]="chartPlugins"
        >
        </canvas>
        <span>
          {{ gaugeChartData()?.datasets?.[0]?.data?.[0] ?? 0 }}%
        </span>
      </div>
    </div>
    <div class="partner-success-card chart-card">
      <div class="chart-card-header">
        <h2> Overall Health </h2>
      </div>
      <div class="health-chart-container">
        <canvas
          baseChart
          #healthPieChart
          id="health-pie-chart"
          type="pie"
          [data]="pieChartData()"
          [options]="pieChartOptions"
          [plugins]="chartPlugins"
        >
        </canvas>
      </div>
    </div>
  </div>

  <div class="partner-success-health-container">
    <wf-partner-success-health [scores]="schoolHealthScores() ?? []"/>
  </div>
</div>
